export default "__VITE_ASSET__6sb56$24__"